{
 "formatVersion": 1,
 "name": "greybox-01",
 "displayName": "Greybox 01",
 "description": "P0/P1 test geometry. Not a level \u2014 a fixture with one of each situation the character controller has to get right: flat floor, perimeter walls, a free-standing block, a 0.3m step, and a 1.2m gap.",
 "visual": null,
 "brushes": [
  {
   "kind": "box",
   "center": [
    0,
    -0.5,
    0
   ],
   "halfExtents": [
    32,
    0.5,
    32
   ],
   "note": "floor, top surface exactly at y=0"
  },
  {
   "kind": "box",
   "center": [
    0,
    2,
    -32
   ],
   "halfExtents": [
    32,
    2,
    0.5
   ],
   "note": "perimeter wall -Z"
  },
  {
   "kind": "box",
   "center": [
    0,
    2,
    32
   ],
   "halfExtents": [
    32,
    2,
    0.5
   ],
   "note": "perimeter wall +Z"
  },
  {
   "kind": "box",
   "center": [
    -32,
    2,
    0
   ],
   "halfExtents": [
    0.5,
    2,
    31.5
   ],
   "note": "perimeter wall -X"
  },
  {
   "kind": "box",
   "center": [
    32,
    2,
    0
   ],
   "halfExtents": [
    0.5,
    2,
    31.5
   ],
   "note": "perimeter wall +X"
  },
  {
   "kind": "box",
   "center": [
    0,
    1,
    -8
   ],
   "halfExtents": [
    2,
    1,
    2
   ],
   "note": "free-standing block: corner sliding"
  },
  {
   "kind": "box",
   "center": [
    8,
    0.15,
    0
   ],
   "halfExtents": [
    2,
    0.15,
    2
   ],
   "note": "0.3m step: must be walkable without a jump"
  },
  {
   "kind": "box",
   "center": [
    -8,
    1,
    -2.6
   ],
   "halfExtents": [
    2,
    1,
    2
   ],
   "note": "gap wall A"
  },
  {
   "kind": "box",
   "center": [
    -8,
    1,
    2.6
   ],
   "halfExtents": [
    2,
    1,
    2
   ],
   "note": "gap wall B \u2014 1.2m gap, a 0.8m player fits"
  }
 ],
 "spawns": [
  {
   "position": [
    0,
    0,
    0
   ],
   "yaw": 0,
   "team": 0
  },
  {
   "position": [
    4,
    0,
    4
   ],
   "yaw": 3.141592653589793,
   "team": 1
  },
  {
   "position": [
    -4,
    0,
    -4
   ],
   "yaw": 0,
   "team": 0
  },
  {
   "position": [
    4,
    0,
    -4
   ],
   "yaw": 1.5707963267948966,
   "team": 1
  }
 ],
 "sites": [
  {
   "id": "A",
   "center": [
    0,
    1,
    20
   ],
   "halfExtents": [
    4,
    2,
    4
   ]
  },
  {
   "id": "B",
   "center": [
    0,
    1,
    -20
   ],
   "halfExtents": [
    4,
    2,
    4
   ]
  }
 ]
}
